import React from 'react';
import { injectIntl } from 'react-intl';
import ListAsyncMultiple from 'components/layout/subscriptions/ListAsyncMultiple';

class ListCompanyAndClient extends React.Component {
  listItemFormatter = ({ profile, type }) => {
    if (type === 'employee') {
      return profile.first_name + ' ' + profile.last_name;
    }
    if (type === 'customer') {
      return profile.company;
    }
  };

  listItemId = client => {
    return client.username;
  };

  render() {
    const {
      intl: { messages },
      paramName,
      getCompaniesAndClients1,
      getCompaniesAndClients2,
      removeData,
      dataInitialValues,
    } = this.props;

    return (
      <ListAsyncMultiple
        title={messages.subscription_clients_and_companies}
        listName="sub_cos_and_cls"
        listUrl="/api/clients.json"
        listUrlData={{ depth: 'shallow' }}
        listItemFormatter={this.listItemFormatter}
        listItemId={this.listItemId}
        paramName={paramName}
        getCompaniesAndClients1={getCompaniesAndClients1}
        getCompaniesAndClients2={getCompaniesAndClients2}
        removeData={removeData}
        dataInitialValues={dataInitialValues}
      />
    );
  }
}
ListCompanyAndClient.defaultProps = {
  paramName: 'target',
};

export default injectIntl(ListCompanyAndClient);
